import {constants} from "../../constants";

export const toggleChangeLanguageModal = () => {
    return { type: constants.CHANGE_LANGUAGE_MODAL_ACTION };
};
